import React, { useContext } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import PropTypes from 'prop-types';
import { PropertyRow } from '@bingads-webui-campaign-react/ui-generator';
import { UrlOptionsDetailsWithRules } from '@bingads-webui-campaign-react/url-rules';
import { UrlOptionsDetailsWithRulesV2 } from '@bingads-webui-campaign-react/url-rules-v2';

export const UrlRules = ({ data, isAssetGroupUrlRulesV2Enabled }) => {
  const i18n = useContext(I18nContext);
  const {
    finalUrls, path1, path2, mobileFinalUrls, urlRules,
  } = data || {};

  return (
    <PropertyRow propertyLabel={{ label: _TL_('Advanced URL options') }}>
      {
        isAssetGroupUrlRulesV2Enabled ? (
          <UrlOptionsDetailsWithRulesV2
            i18n={i18n}
            finalUrls={finalUrls}
            path1={path1}
            path2={path2}
            mobileFinalUrls={mobileFinalUrls}
            urlRules={urlRules}
          />
        ) : (
          <UrlOptionsDetailsWithRules
            i18n={i18n}
            finalUrls={finalUrls}
            path1={path1}
            path2={path2}
            mobileFinalUrls={mobileFinalUrls}
            urlRules={urlRules}
          />
        )
      }
    </PropertyRow>
  );
};

UrlRules.propTypes = {
  data: PropTypes.shape({
    finalUrls: PropTypes.arrayOf(PropTypes.string),
    path1: PropTypes.string,
    path2: PropTypes.string,
    mobileFinalUrls: PropTypes.arrayOf(PropTypes.string),
    urlRules: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  isAssetGroupUrlRulesV2Enabled: PropTypes.bool,
};

UrlRules.defaultProps = {
  data: {
    finalUrls: [],
    path1: '',
    path2: '',
    mobileFinalUrls: [],
    urlRules: [],
  },
};
